import NewCollectionSection from './NewCollectionSection';
export default NewCollectionSection;
